import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _Set from '@babel/runtime-corejs3/core-js-stable/set';
import React__default, { useState, useMemo } from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { DropdownHeaderContextProvider } from './c1e6a01ba90d5c5ded3a4403377b02a83d19fc3dff1744450eb179ec9cd1cc80.cfe-internal.js';
import { useDropdownContext } from './96f486109d0d2850b21eef94a8c44cc3323a66fb525ca5574171063673f9afca.cfe-internal.js';
import { FlyoutHeader } from '../../utils/Flyout/64d9a6e73c9e4029974675d0c2b1dacdf7a73b9daa66e1961b492c2a5db7a276.cfe-internal.js';

var _excluded = ["title", "children"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var DropdownHeader = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var title = _ref.title,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var commonProps = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref
  });
  var _useDropdownContext = useDropdownContext(),
    searchValue = _useDropdownContext.searchValue;
  var _useState = useState(new _Set()),
    _useState2 = _slicedToArray(_useState, 2),
    visibleChildIds = _useState2[0],
    setVisibleChildIds = _useState2[1];
  var isVisible = useMemo(function () {
    return !searchValue || searchValue && visibleChildIds.size > 0;
  }, [visibleChildIds, searchValue]);
  return /*#__PURE__*/React__default.createElement(DropdownHeaderContextProvider, {
    value: {
      setVisibleChildIds: setVisibleChildIds
    }
  }, isVisible ? /*#__PURE__*/React__default.createElement(FlyoutHeader, _extends({
    title: title
  }, commonProps), children) : /*#__PURE__*/React__default.createElement("div", commonProps, children));
});
var DropdownHeader$1 = DropdownHeader;

export { DropdownHeader$1 as default };
